import { isHashSet as isHashSet$1, empty as empty$1, fromIterable as fromIterable$1, make as make$1, has as has$1, some as some$1, every as every$1, isSubset as isSubset$1, values as values$1, size as size$1, beginMutation as beginMutation$1, endMutation as endMutation$1, mutate as mutate$1, add as add$1, remove as remove$1, difference as difference$1, intersection as intersection$1, union as union$1, toggle as toggle$1, map as map$1, flatMap as flatMap$1, forEach as forEach$1, reduce as reduce$1, filter as filter$1, partition as partition$1 } from '../../internal/HashSet.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category refinements
 */
const isHashSet = isHashSet$1;

/**
 * Creates an empty `HashSet`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Construct a new `HashSet` from a `Collection` of values
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = fromIterable$1;

/**
 * Construct a new `HashSet` from a variable number of values.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Checks if the specified value exists in the `HashSet`.
 *
 * @since 2.0.0
 * @category elements
 */
const has = has$1;

/**
 * Check if a predicate holds true for some `HashSet` element.
 *
 * @since 2.0.0
 * @category elements
 */
const some = some$1;

/**
 * Check if a predicate holds true for every `HashSet` element.
 *
 * @since 2.0.0
 * @category elements
 */
const every = every$1;

/**
 * Returns `true` if and only if every element in the this `HashSet` is an
 * element of the second set,
 *
 * **NOTE**: the hash and equal of both sets must be the same.
 *
 * @since 2.0.0
 * @category elements
 */
const isSubset = isSubset$1;

/**
 * Returns an `IterableIterator` of the values in the `HashSet`.
 *
 * @since 2.0.0
 * @category getters
 */
const values = values$1;

/**
 * Calculates the number of values in the `HashSet`.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Marks the `HashSet` as mutable.
 *
 * @since 2.0.0
 */
const beginMutation = beginMutation$1;

/**
 * Marks the `HashSet` as immutable.
 *
 * @since 2.0.0
 */
const endMutation = endMutation$1;

/**
 * Mutates the `HashSet` within the context of the provided function.
 *
 * @since 2.0.0
 */
const mutate = mutate$1;

/**
 * Adds a value to the `HashSet`.
 *
 * @since 2.0.0
 */
const add = add$1;

/**
 * Removes a value from the `HashSet`.
 *
 * @since 2.0.0
 */
const remove = remove$1;

/**
 * Computes the set difference between this `HashSet` and the specified
 * `Iterable<A>`.
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same.
 *
 * @since 2.0.0
 */
const difference = difference$1;

/**
 * Returns a `HashSet` of values which are present in both this set and that
 * `Iterable<A>`.
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same.
 *
 * @since 2.0.0
 */
const intersection = intersection$1;

/**
 * Computes the set union `(`self` + `that`)` between this `HashSet` and the
 * specified `Iterable<A>`.
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same.
 *
 * @since 2.0.0
 */
const union = union$1;

/**
 * Checks if a value is present in the `HashSet`. If it is present, the value
 * will be removed from the `HashSet`, otherwise the value will be added to the
 * `HashSet`.
 *
 * @since 2.0.0
 */
const toggle = toggle$1;

/**
 * Maps over the values of the `HashSet` using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = map$1;

/**
 * Chains over the values of the `HashSet` using the specified function.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap = flatMap$1;

/**
 * Applies the specified function to the values of the `HashSet`.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEach = forEach$1;

/**
 * Reduces the specified state over the values of the `HashSet`.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce = reduce$1;

/**
 * Filters values out of a `HashSet` using the specified predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
const filter = filter$1;

/**
 * Partition the values of a `HashSet` using the specified predicate.
 *
 * If a value matches the predicate, it will be placed into the `HashSet` on the
 * right side of the resulting `Tuple`, otherwise the value will be placed into
 * the left side.
 *
 * @since 2.0.0
 * @category partitioning
 */
const partition = partition$1;

export { add, beginMutation, difference, empty, endMutation, every, filter, flatMap, forEach, fromIterable, has, intersection, isHashSet, isSubset, make, map, mutate, partition, reduce, remove, size, some, toggle, union, values };
